import { IonItem, IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import { useContext } from "react";
import { ThemeContext } from "../util/ThemeManager";
import { ThemePreference } from "../models/common/ThemePreference";
import { TranslationsContext } from "../util/Translations";

const ThemeSelector: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const { themePreference, setThemePreference } = useContext(ThemeContext);

  return (
    <IonItem lines="full">
      <IonLabel position="stacked">{translations["lbl_theme"] || "Theme"}</IonLabel>
      <IonSegment
        className="settings-theme-segment"
        value={themePreference}
        onIonChange={(event) => {
          if (!setThemePreference || !event.detail.value) return;
          setThemePreference(event.detail.value as ThemePreference);
        }}
      >
        <IonSegmentButton value={ThemePreference.default}>
          <IonLabel>{translations["lbl_system_default"] || "System Default"}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={ThemePreference.light}>
          <IonLabel>{translations["lbl_light"] || "Light"}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={ThemePreference.dark}>
          <IonLabel>{translations["lbl_dark"] || "Dark"}</IonLabel>
        </IonSegmentButton>
      </IonSegment>
    </IonItem>
  );
};

export default ThemeSelector;
